import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import {
    IApproverInterface,
    IReimbursement,
    IReimbursementData,
    ISingleReimbursement,
    ReimbursementDataCreateRes
} from './interface';
import { inject, Injectable } from '@angular/core';
import { ReimbursementService } from './requests.service';
import {
    ClearReimbursments,
    CreateReimbursment,
    DeleteReimbursment,
    DeleteReq,
    GetAllRequests,
    GetApproverRequests,
    GetByUser,
    GetSingleReimbursmentRequest,
    SubmitReimbursment
} from './action';
import { catchError, tap } from 'rxjs';

export class IProps {
    reimbursments!: IReimbursement[];

    reimbursment!: ISingleReimbursement | null;
    getReimbursmentDatas!: ReimbursementDataCreateRes[];
    approverResponse!: IApproverInterface[];
    getReimbursmentData!: ReimbursementDataCreateRes | null;
    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'reimbursment',
    defaults: {
        reimbursments: [],
        approverResponse: [],
        getReimbursmentDatas: [],
        getReimbursmentData: null,
        reimbursment: null,

        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class ReimbursementStore {
    requestsService: ReimbursementService = inject(ReimbursementService);
    private store: Store = inject(Store);

    @Selector()
    static getReimbursments(state: IProps) {
        return state.reimbursments;
    }
    @Selector()
    static getApproversReimbursments(state: IProps) {
        return state.approverResponse;
    }
    @Selector()
    static getReimbursmentDatas(state: IProps) {
        return state.getReimbursmentDatas;
    }
    @Selector()
    static getReimbursmentData(state: IProps) {
        return state.getReimbursmentData;
    }
    @Selector()
    static singleReimbursment(state: IProps) {
        return state.reimbursment;
    }

    @Selector()
    static getUserReimbursments(state: IProps) {
        return state.reimbursments;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }
    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getAllReimbursments(action.queryParams as any).pipe(
            tap((res) => {
                ctx.patchState({
                    reimbursments: res.map((r: any) => ({
                        ...r,
                        reimbursement:
                            Array.isArray(r.reimbursement) && r.reimbursement.length > 0
                                ? r.reimbursement[0]
                                : null
                    })),
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(CreateReimbursment)
    createReimbursment(ctx: StateContext<IProps>, action: CreateReimbursment) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createReimbursment(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    getReimbursmentData: res,

                    getReimbursmentDatas: [...state.getReimbursmentDatas, res],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(SubmitReimbursment)
    submitReimbursment(ctx: StateContext<IProps>, action: SubmitReimbursment) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });
        return this.requestsService.submitReimbursment(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    reimbursments: [...state.reimbursments, res],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleReimbursmentRequest)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleReimbursmentRequest) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingleReimbursment(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    reimbursment: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetByUser)
    getByUser(ctx: StateContext<IProps>, action: GetByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getByUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    reimbursments: res.map((r) => ({
                        ...r,
                        reimbursement:
                            Array.isArray(r.reimbursement) && r.reimbursement.length > 0
                                ? r.reimbursement[0]
                                : null
                    })),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(DeleteReimbursment)
    delete(ctx: StateContext<IProps>, action: DeleteReimbursment) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.deleteReimbursment(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    getReimbursmentDatas: state.getReimbursmentDatas.filter(
                        (r) => r.reimbursement?.id !== action.id
                    ),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(DeleteReq)
    deleteOver(ctx: StateContext<IProps>, action: DeleteReq) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.deleteReq(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    reimbursments: state.reimbursments.filter((r) => r?.id !== action.id),
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    // @Action(AddRequestComment)
    // addComment(ctx: StateContext<IProps>, action: AddRequestComment) {
    //     const state = ctx.getState();
    //     ctx.patchState({ loading: true });

    //     return this.requestsService.comment(action.input).pipe(
    //         tap((res) => {
    //             ctx.patchState({
    //                 // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
    //                 loading: false
    //             });
    //         }),
    //         catchError((err) => {
    //             ctx.patchState({
    //                 loading: false,
    //                 error: err.message
    //             });
    //             throw err;
    //         })
    //     );
    // }
    @Action(GetApproverRequests)
    getApproverRequest(ctx: StateContext<IProps>, action: GetApproverRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    approverResponse: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(ClearReimbursments)
    clearReimbursments(ctx: StateContext<IProps>, action: ClearReimbursments) {
        ctx.patchState({
            getReimbursmentDatas: [] // or whatever the key is
        });
    }
}
